import React from "react";

import { getTranslations } from "./translations";

const locale = "en_US";
const TranslationContext = React.createContext(getTranslations()[locale]);

export default TranslationContext;
